// Dependencias generales
import React from "react";
import { useEffect, useState } from 'react';
import ReactGA from "react-ga4";
import EnergyBilling from './Advisory/EnergyBilling'
import CommunityBilling from './Advisory/CommunityBilling'
import AppliancesReplacement from './Advisory/AppliancesReplacement'
import ConsumptionControl from './Advisory/ConsumptionControl'
import AlternativeEnergySources from './Advisory/AlternativeEnergySources'
import BatteriesInstallation from './Advisory/BatteriesInstallation'
import AlternativeTransportation from './Advisory/AlternativeTransportation'
import EnergySurplus from './Advisory/EnergySurplus'
import FeesAnalyzer from './Advisory/FeesAnalyzer'
import Loader from '../../components/Utils/Loader'
import Connectivity from "./Advisory/Connectivity.js";

const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const lastDashboardDataRequestURL = endpointHelias+'/Helias/V0/General/lastDashboardData'

var initialConfigCommonJS = require("../../js/initialConfigCommon.js")
var generalCommonJS = require("../../js/generalCommon.js")
var advisoryCommonJS = require("../../js/advisoryCommon.js")
var stripeCommonJS = require("../../js/stripeCommon.js")

var objDatosDashboard = []

// CONFIGURACIÓN
const Advisory = (params) => {

  const [selectedAdvisoryOption, setSelectedAdvisoryOption] = useState("")  

  useEffect(() => {    
    stripeCommonJS.verificarSuscripcion(cargaTotalInicialAdvisory)
    generalCommonJS.autocierrePrivacidadGoogle()
  }, [])

  function cargaTotalInicialAdvisory(){

    if((localStorage.getItem("lastDashboardData") === null) && (Object.keys(objDatosDashboard).length === 0)){cargarDashboard()}
    else{
      objDatosDashboard = JSON.parse(localStorage.getItem("lastDashboardData"))      
      document.getElementById("loaderGeneralAplicacion").className = "loader hidden"
    }

    if( (typeof(params.selectedOption) !== "undefined") && (params.selectedOption !== "") ){
      seleccionarOpcionAdvisory(params.selectedOption)              
    }

    advisoryCommonJS.verificarConsejosAplicables()

  }

  function cargarDashboard(){
          
    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")        
  
    document.getElementById("loaderGeneralAplicacion").className = "loader"
  
    //Petición de datos para el paso actual
    var jsonPeticion = {
      "accountID": localStorage.getItem("accountID"),
      "installationID": localStorage.getItem("installationId") 
    }
  
    // Guardo la información  
    var xhttp = new XMLHttpRequest();  
      xhttp.open("POST", lastDashboardDataRequestURL, true);        
      xhttp.setRequestHeader('Content-Type', "application/json");
      xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
      var data = JSON.stringify(jsonPeticion);
      xhttp.onreadystatechange = function() {
        if (this.readyState === 4 && this.status === 200) {
          var jsonRespuesta = JSON.parse(this.responseText)
    
          if(jsonRespuesta.statusCode === "403"){                   
            initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
          }
          else{          
            //Si recibo datos ya configurados lo cargo  
  
            if(typeof jsonRespuesta.body !== 'undefined'){                  
              console.log(jsonRespuesta)                
              objDatosDashboard = jsonRespuesta.body   
              localStorage.setItem("lastDashboardData", JSON.stringify(jsonRespuesta.body))     
            }  
  
            //Si no hay datos configurados entonces no hago nada  
            console.log("Datos del dashboard cargados correctamente.")
            document.getElementById("loaderGeneralAplicacion").className = "loader hidden"
                
          }
        }
    
        if (this.readyState === 4 && this.status !== 200) {      
          initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)          
        }
      }
      xhttp.send(data);     
    
  }

  function seleccionarOpcionAdvisory(opcion){

    document.getElementById("divContenedorDetalleAdvisory").scrollTop = 0

    document.getElementById("asideDetalleAdvisory").className = document.getElementById("asideDetalleAdvisory").className.replace(" hidden", "")

    var componente = ""
    var tituloDetalle = ""
    var iconoDetalle = "" 

    if ((opcion === "") || (typeof(opcion) === "undefined")){
      componente = <EnergyBilling objDatosDashboard={objDatosDashboard}/>
      tituloDetalle  = "Contrato de luz"
      iconoDetalle = "offline_bolt"
      generalCommonJS.registrarEventoAnalitica(ReactGA, 'ASESORAMIENTO', 'ASESORAMIENTO - '+tituloDetalle, "", "")
    }else{
      if(opcion === "EnergyBilling"){ 
        componente = <EnergyBilling objDatosDashboard={objDatosDashboard} seleccionarOpcionAdvisory={seleccionarOpcionAdvisory}/>
        tituloDetalle  = "Contrato de luz"
        iconoDetalle = "offline_bolt"
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'ASESORAMIENTO', 'ASESORAMIENTO - '+tituloDetalle, "", "")
      }
      else if(opcion === "FeesAnalyzer"){ 
        componente = <FeesAnalyzer objDatosDashboard={objDatosDashboard} subOption={params.subOption}/>
        tituloDetalle  = "Análisis de tarifas"
        iconoDetalle = "euro"
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'ASESORAMIENTO', 'ASESORAMIENTO - '+tituloDetalle, "", "")
      }            
      else if(opcion === "CommunityBilling"){ 
        componente = <CommunityBilling objDatosDashboard={objDatosDashboard} seleccionarOpcionAdvisory={seleccionarOpcionAdvisory}/>
        tituloDetalle  = "Comunidad de vecinos"
        iconoDetalle = "apartment"
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'ASESORAMIENTO', 'ASESORAMIENTO - '+tituloDetalle, "", "")
      }
      else if(opcion === "AlternativeEnergySources"){ 
        componente = <AlternativeEnergySources/>
        tituloDetalle  = "Paneles solares"
        iconoDetalle = "solar_power"
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'ASESORAMIENTO', 'ASESORAMIENTO - '+tituloDetalle, "", "")
      }
      else if(opcion === "BatteriesInstallation"){ 
        componente = <BatteriesInstallation/>
        tituloDetalle  = "Baterías"
        iconoDetalle = "battery_charging_full"
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'ASESORAMIENTO', 'ASESORAMIENTO - '+tituloDetalle, "", "")
      }
      else if(opcion === "AlternativeTransportation"){ 
        componente = <AlternativeTransportation/>
        tituloDetalle  = "Movilidad eléctrica"
        iconoDetalle = "electric_car"
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'ASESORAMIENTO', 'ASESORAMIENTO - '+tituloDetalle, "", "")
      }    
      else if(opcion === "ConsumptionControl"){ 
        componente = <ConsumptionControl/>
        tituloDetalle  = "Dispositivos inteligentes"
        iconoDetalle = "devices_other"
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'ASESORAMIENTO', 'ASESORAMIENTO - '+tituloDetalle, "", "")
      }
      else if(opcion === "Connectivity"){ 
        componente = <Connectivity/>
        tituloDetalle  = "Conectividad"
        iconoDetalle = "wifi"
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'ASESORAMIENTO', 'ASESORAMIENTO - '+tituloDetalle, "", "")
      }
      else if(opcion === "AppliancesReplacement"){ 
        componente = <AppliancesReplacement/>
        tituloDetalle  = "Sustitución de electrodomésticos"
        iconoDetalle = "microwave"                
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'ASESORAMIENTO', 'ASESORAMIENTO - '+tituloDetalle, "", "")
      }
      else if(opcion === "EnergySurplus"){ 
        componente = <EnergySurplus objDatosDashboard={objDatosDashboard}/>
        tituloDetalle  = "Excedente energético"
        iconoDetalle = "output"                
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'ASESORAMIENTO', 'ASESORAMIENTO - '+tituloDetalle, "", "")
      }      

    }

    document.getElementById("iconoDetalleAdvisory").innerHTML = iconoDetalle
    document.getElementById("tituloDetalleAdvisory").innerHTML = tituloDetalle

    

    setSelectedAdvisoryOption(componente)
  }

  function gestionarVisibilidadDetalleAdvisory(event){        
    if ( (document.getElementById("asideDetalleAdvisory") !== null) && !document.getElementById("asideDetalleAdvisory").className.includes("hidden") && (event.target.id === "asideDetalleAdvisory") ){
      cerrarDetalle()
    }
  }

  function cerrarDetalle(){
    
    if(localStorage.getItem("deepLinkBack") !== null){
      localStorage.removeItem("deepLinkBack")
      window.location = "/Dashboard"
    }
    else{ //Procedo normalmente.
      document.getElementById("asideDetalleAdvisory").className += " hidden"
      
      if(document.getElementById("detalleAdvisoryFuentesAlternativasEnergia") !== null){

        if(document.getElementById("divFormulario").className.includes(" hidden")){        
          document.getElementById("divFormulario").className = document.getElementById("divFormulario").className.replace(" hidden", "")                  
          document.getElementById("selectTipoSuperficieInstalacion").selectedIndex  = 0
          document.getElementById("anchoSuperficieInstalacion").value  = ""
          document.getElementById("largoSuperficieInstalacion").value  = ""
          document.getElementById("selectOrientacionTejado").selectedIndex  = 0          
          document.getElementById("divTablaResultados").className = document.getElementById("divTablaResultados").className.replaceAll(" hidden","") + " hidden"
        }

      }

      if( (typeof(params.selectedOption) !== "undefined") && (params.selectedOption !== "") ){
        window.location = "/Advisory"
      }
    }
    
  }

  return (

    <>

        <section id="seleccionOpcionAdvisory" className="step wrapper config gap-08">

          <div className="description comment bubble" onClick={() => generalCommonJS.gestionarVisibilidadBubbleIntro("textoIntroAsesoramiento")}>        
            <h1 className="headline-03 no-helias"><span className="fill">Asesoramiento</span><button className="link"><span className="material-icon" >info</span></button></h1>
            <div id="textoIntroAsesoramiento" className=" hidden"><p>Aquí tienes una serie de consejos para conseguir una máxima eficiencia y ahorro.</p></div>
          </div> 

          <div className="content-wrapper horizontal">

              <div id="divOpcionesAdvisory" className="vertical gap-06">  

                <div className="row">

                  <div id="advisoryContratoLuz" className="col-md-6 col-lg-4 hidden pointer" onClick={() => seleccionarOpcionAdvisory("EnergyBilling")}>

                    <section className="widget bubble advice" >
                      <div className="vertical gap-04">
                        <div className="gap-03 horizontal vertical-center">
                          <figure id="figureContratoLuz" className="avatar size-l pink"><span id="iconoContratoLuz" className="material-icon">offline_bolt</span></figure>
                          <h1 className="headline-03 fill">Contrato de luz</h1>                          
                        </div>
                        <p id="introContratoLuz">Consideraciones a tener en cuenta para reducir tu factura de luz.</p>
                      </div>
                      <button id="botonContratoLuz" className="link" >Veamos</button>
                    </section>

                  </div>

                  <div id="advisoryComunidadesVecinos" className="col-md-6 col-lg-4 hidden pointer" onClick={() => seleccionarOpcionAdvisory("CommunityBilling")}>

                    <section className="widget bubble advice">
                      <div className="vertical gap-04">
                        <div className="gap-03 horizontal vertical-center">
                          <figure id="figureComunidadesVecinos" className="avatar size-l pink"><span id="iconoComunidadesVecinos" className="material-icon">apartment</span></figure>
                          <h1 className="headline-03 fill">Comunidad de vecinos</h1>                          
                        </div>
                        <p id="introComunidadesVecinos">Consideraciones a tener en cuenta para reducir tu factura de luz.</p>
                      </div>
                      <button id="botonComunidadesVecinos" className="link" >Comprobémoslo</button>
                    </section>

                  </div>  

                  <div id="advisoryAnalizadorTarifas" className="col-md-6 col-lg-4 hidden pointer" onClick={() => seleccionarOpcionAdvisory("FeesAnalyzer")}>

                    <section className="widget bubble advice" >
                      <div className="vertical gap-04">
                        <div className="gap-03 horizontal vertical-center">
                          <figure id="figureAnalizadorTarifas" className="avatar size-l pink"><span id="iconoAnalizadorTarifas" className="material-icon">euro</span></figure>
                          <h1 className="headline-03 fill">Analizador de tarífas</h1>                          
                        </div>
                        <p id="introAnalizadorTarifas">¿Te han hecho una oferta y no sabes si te conviene?¿No la tienes pero quieres que diga si hay alguna que mejore la tuya?</p>
                      </div>
                      <button id="botonAnalizadorTarifas" className="link" >Sí, vamos a ello</button>
                    </section>

                  </div>

                  <div id="advisorySustitucionElectrodomesticos" className="col-md-6 col-lg-4 hidden pointer" onClick={() => seleccionarOpcionAdvisory("AppliancesReplacement")}>

                    <section className="widget bubble advice">
                      <div className="vertical gap-04">
                        <div className="gap-03 horizontal vertical-center">
                          <figure id="figureSustitucionElectrodomesticos" className="avatar size-l pink"><span id="iconoSustitucionElectrodomesticos" className="material-icon">microwave</span></figure>
                          <h1 className="headline-03 fill">Sustitución de electrodomésticos</h1>                          
                        </div>
                        <p id="introSustitucionElectrodomesticos">El consumo de los electrodomésticos antiguos es altísimo, comprueba si necesitas sustituir alguno.</p>
                      </div>
                      <button id="botonSustitucionElectrodomesticos" className="link" >Veámoslo</button>
                    </section>

                  </div>  

                  <div id="advisoryControlConsumo" className="col-md-6 col-lg-4 hidden pointer" onClick={() => seleccionarOpcionAdvisory("ConsumptionControl")}>

                    <section className="widget bubble advice">
                      <div className="vertical gap-04">
                        <div className="gap-03 horizontal vertical-center">
                          <figure id="figureControlConsumo" className="avatar size-l pink"><span id="iconoControlConsumo" className="material-icon">devices_other</span></figure>
                          <h1 className="headline-03 fill">Dispositivos inteligentes</h1>                          
                        </div>
                        <p id="introControlConsumo">Usar dispositivos inteligentes te servirá para ahorrar automatizando tareas, ayudando a controlar gastos innecesarios por descuidos.</p>
                      </div>
                      <button id="botonControlConsumo" className="link" >¿Cuáles me recomiendas?</button>
                    </section>

                  </div>

                  <div id="advisoryConectividad" className="col-md-6 col-lg-4 pointer" onClick={() => seleccionarOpcionAdvisory("Connectivity")}>

                    <section className="widget bubble advice">
                      <div className="vertical gap-04">
                        <div className="gap-03 horizontal vertical-center">
                          <figure id="figureControlConsumo" className="avatar size-l pink"><span id="iconoControlConsumo" className="material-icon">wifi</span></figure>
                          <h1 className="headline-03 fill">Conectividad</h1>                          
                        </div>
                        <p>¿Tienes problemas de conectividad con tus dispositivos o no sabes cómo llevar el WIFI a un sitio concreto de tu instalación?</p>
                      </div>
                      <button className="link">Sí, ¿cómo lo resuelvo?</button>
                    </section>

                  </div>

                  <div id="advisoryFuentesAlternativasEnergia" className="col-md-6 col-lg-4 hidden pointer" onClick={() => seleccionarOpcionAdvisory("AlternativeEnergySources")}>

                    <section className="widget bubble advice">
                      <div className="vertical gap-04">
                        <div className="gap-03 horizontal vertical-center">
                          <figure id="figureFuentesAlternativasEnergia" className="avatar size-l pink"><span id="iconoFuentesAlternativasEnergia" className="material-icon">solar_power</span></figure>
                          <h1 className="headline-03 fill">Paneles solares</h1>                          
                        </div>
                        <p id="introFuentesAlternativasEnergia">¿Quieres que te ayude a ver si te interesa instalar paneles solares?</p>
                      </div>
                      <button id="botonFuentesAlternativasEnergia" className="link" >¡Por supuesto!</button>
                    </section>

                  </div>

                  <div id="advisoryAprovechamientoExcedenteEnergetico" className="col-md-6 col-lg-4 hidden pointer" onClick={() => seleccionarOpcionAdvisory("EnergySurplus")}>

                    <section className="widget bubble advice">
                      <div className="vertical gap-04">
                        <div className="gap-03 horizontal vertical-center">
                          <figure id="figureAprovechamientoExcedenteEnergetico" className="avatar size-l pink"><span id="iconoAprovechamientoExcedenteEnergetico" className="material-icon">output</span></figure>
                          <h1 className="headline-03 fill">Excedente energético</h1>                          
                        </div>
                        <p id="introAprovechamientoExcedenteEnergetico">¿Le estás regalando tu excedente energético a tu compañía eléctrica y no sabes que hacer?</p>
                      </div>
                      <button id="botonAprovechamientoExcedenteEnergetico" className="link" >Sí, ¿qué hago?</button>
                    </section>

                  </div>

                  <div id="advisoryBaterias" className="col-md-6 col-lg-4 hidden pointer" onClick={() => seleccionarOpcionAdvisory("BatteriesInstallation")}>

                    <section className="widget bubble advice">
                      <div className="vertical gap-04">
                        <div className="gap-03 horizontal vertical-center">
                          <figure id="figureInstalacionBaterias" className="avatar size-l pink"><span id="iconoInstalacionBaterias" className="material-icon">battery_charging_full</span></figure>
                          <h1 className="headline-03 fill">Baterías</h1>                          
                        </div>
                        <p id="introInstalacionBaterias">¿Quieres que te ayude a ver si te interesa instalar baterías?</p>
                      </div>
                      <button id="botonInstalacionBaterias" className="link" >¡Por supuesto!</button>
                    </section>

                  </div>

                  <div id="advisoryMediosAlternativosTransporte" className="col-md-6 col-lg-4 hidden pointer" onClick={() => seleccionarOpcionAdvisory("AlternativeTransportation")}>

                    <section className="widget bubble advice">
                      <div className="vertical gap-04">
                        <div className="gap-03 horizontal vertical-center">
                          <figure id="figureMediosTransporteAlternativos" className="avatar size-l pink"><span id="iconoMediosTransporteAlternativos" className="material-icon">electric_car</span></figure>
                          <h1 className="headline-03 fill">Movilidad eléctrica</h1>                          
                        </div>
                        <p id="introMediosTransporteAlternativos">¿Te estás arruinando con tu coche gasolina / diesel / híbrido o estás pensando en comprarte otro coche eléctrico?</p>
                      </div>
                      <button id="botonMediosTransporteAlternativos" className="link" >Veamos alternativas</button>
                    </section>

                  </div>  

                </div>   

              </div>

          </div>

        </section>

        <aside id="asideDetalleAdvisory" className="modal lateral-detail half hidden" onMouseDown={gestionarVisibilidadDetalleAdvisory}>

          <div id="divContenedorDetalleAdvisory" className="modal-content">

            <button className="link close" onClick={() => cerrarDetalle()}><span className="material-icon">highlight_off</span></button>
            <div className="page">

              <section id="detalleAdvisory" className=" " style={{paddingLeft: "-50px"}}>

                <div id="divDetalleAdvisory" className="vertical gap-08">

                  <header className="center">                                
                    <figure id="figureDetalleAdvisory" className="avatar size-xl pink">
                      <span id="iconoDetalleAdvisory" className="material-icon"></span>
                    </figure>
                    <dl className="vertical fill">
                      <dd id="tituloDetalleAdvisory" className="headline-02"></dd>
                    </dl>
                  </header>   

                  <div id="opcionSeleccionada" className="vertical gap-04">
                      {selectedAdvisoryOption}
                  </div>
                
                </div>
                
              </section>

            </div>

            <Loader Id="loaderDetalleAdvisory" Mensaje=""/>

          </div>
          

        </aside>
      
    </>

  )
}

export default Advisory